import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import DirectusService from '@/core/directus/directus.service';
import FooterLinkCMSModel from '@/visa-application/models/FooterLinkCMSModel';
import LanguageCode from '@/locale/language-code';
import FooterCMSModel from '@/visa-application/models/FooterCMSModel';
import { OSANO, MINIO_BUCKET_ADDRESS } from '@/constants';
import _ from 'lodash';
import CountryCMSModel from '@/visa-application/models/CountryCMSModel';
import ApplicationCenterCMSModel from '@/visa-application/models/ApplicationCenterCMSModel';
@Component
export default class JhiFooter extends Vue {
  @Inject('directusService') private directusService: () => DirectusService;

  public issuer = '';
  public logoStyle = MINIO_BUCKET_ADDRESS + '/logo-white.svg';
  public residenceCountryCode = '';
  public currentLanguage: LanguageCode = this.$store.getters.currentLanguage;
  public footerLinkCmsData: FooterLinkCMSModel = new FooterLinkCMSModel();
  public footerCmsData: FooterCMSModel = new FooterCMSModel();
  public osano = OSANO;
  public countryCopyrights = '';
  public MINIO_BUCKET_ADDRESS = MINIO_BUCKET_ADDRESS;
  public isChineseCenter = false;

  @Watch('$store.getters.currentLanguage', { deep: true, immediate: true })
  public onCurrentLanguageChanged(language: LanguageCode): void {
    this.currentLanguage = language;
    this.getFooterCMSContent();
    this.getFooterLinkContent();
    this.getCountryCMSContent();
  }

  @Watch('$route', { deep: true, immediate: true })
  public onRouteChange(route: any) {
    if (route.params.residenceCountryCode) {
      this.residenceCountryCode = route.params.residenceCountryCode;
    }
    if (route.params.issuer) {
      this.issuer = route.params.issuer;
      this.getFooterLinkContent();
      this.isShowFloatingPrompt();
      this.imgLogoFooter();
      this.getCountryCMSContent();
    }
    this.isChineseCenter =
      ['cn'].includes(route.params.residenceCountryCode) || (route.params.issuer && route.params.issuer.startsWith('cn'));
  }

  @Watch('residenceCountryCode', { immediate: true })
  onWatchCountryCode(value) {
    if (value) {
      this.getCountryCMSContent();
    }
  }

  public imgLogoFooter(): void {
    const filters = {
      code: {
        eq: this.issuer
      }
    };
    this.directusService()
      .getCollection<ApplicationCenterCMSModel>(ApplicationCenterCMSModel, 'application_centers', ['*.*'], filters, this.currentLanguage)
      .then((result: ApplicationCenterCMSModel[]) => {
        let logoFooter = '';
        result.forEach(function(item) {
          if (item.website_footer_logo === null) {
            logoFooter = MINIO_BUCKET_ADDRESS + '/logo-white.svg';
          } else {
            logoFooter = item.website_footer_logo.data.url;
          }
        });
        this.logoStyle = logoFooter;
      })
      .catch(error => console.error(error));
  }

  public getFooterCMSContent(): void {
    this.directusService()
      .getCollection<FooterCMSModel>(FooterCMSModel, 'footer', ['*.*'], undefined, this.currentLanguage)
      .then((response: FooterCMSModel[]) => (this.footerCmsData = response[0]))
      .catch(error => console.error(error));
  }

  public getFooterLinkContent(): void {
    if (this.issuer === '') {
      return;
    }
    const filter = {
      'issuer.code': {
        eq: this.issuer
      }
    };

    this.directusService()
      .getCollection<FooterLinkCMSModel>(FooterLinkCMSModel, 'footer_links', ['*.*'], filter, this.currentLanguage)
      .then((response: FooterLinkCMSModel[]) => {
        this.footerLinkCmsData = response[0];
      })
      .catch(error => console.error(error));
  }

  public isShowFloatingPrompt(): void {
    const app = document.getElementById('app');
    if (app.contains(document.getElementsByClassName('tls-application-center-home')[0])) {
      app.classList.add('show-floating-prompt');
    } else {
      app.classList.remove('show-floating-prompt');
    }
  }

  public getCountryCMSContent(): void {
    const filter = {
      code: {
        eq: this.residenceCountryCode
      }
    };

    this.directusService()
      .getCollection<CountryCMSModel>(CountryCMSModel, 'country', ['*.*.*.*'], filter, this.currentLanguage)
      .then((result: CountryCMSModel[]) => {
        this.countryCopyrights = _.get(result, '0.country_copyrights', '');
        this.$nextTick(() => {
          const links: Element = (this.$refs.footerBeian as any).getElementsByTagName('a')[0];
          links.setAttribute('target', '_blank');
        });
      });
  }

  public onOpenOsano(): void {
    try {
      (window as any).Osano.cm.showDrawer();
    } catch (error) {}
  }
}
